import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Icon } from '@marvelapp/ballpark-components';
// eslint-disable-next-line mobx/missing-observer
export default function StopRecording() {
    return (_jsx(Icon, { height: 30, viewBox: "0 0 30 30", width: 30, children: _jsx("rect", { fillRule: "evenodd", height: "12", rx: "2", width: "12", x: "9", y: "9" }) }));
}
